"use strict"
import './components/banner-video'
import './components/config'
import './components/header'
import './components/animations'
import './components/lazy'
import './components/popup'
// import './components/sliders'
// import './components/dropdown'
// import './components/tabs'
// import './components/modal'
// import './components/gallery'
